import { Model } from 'casbin';
const model = new Model();
model.addDef('r', 'r', 'subject, domain, object, action');
model.addDef('p', 'p', 'subject, domain, object, action');
model.addDef('g', 'g', '_, _, _');
model.addDef('e', 'e', 'some(where (p.eft == allow))');
model.addDef('m', 'm', 'g(r.subject, p.subject, r.domain) && r.domain == p.domain && r.object == p.object && r.action == p.action');
export { model };
//# sourceMappingURL=casbin-model.js.map